import React from 'react';
import styled, { css } from 'styled-components';
import { ColorTokens, PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme, ThemeMode } from '@shapeable/theme';
import { BANNER_KNOWLEDGE_HUB, createIntroSlice } from '../../data';
import { DARK_BLUE_OVERLAY, ORANGE } from '../../theme';
import { EntityTitleHeader } from '@shapeable/ui';

// -------- Child Component Props -------->

type ContainerProps = {
  slug?: string;
}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
};

export const PageLayoutIndigenousVoices: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;
  const { content, intro } = entity;

  const headerColors: ColorTokens.TextBackground = {
    text: 'light',
  };

  return (
    <My.Container 
      className={className}
    >
    <EntityTitleHeader showTitle={false} colors={headerColors} overlayColor={DARK_BLUE_OVERLAY} backgroundImage={BANNER_KNOWLEDGE_HUB} entity={entity} />
    {slices}
    </My.Container>
  )
};
